import { Routes, Route } from "react-router-dom";
import DashboardLayout from "./layouts/DashboardLayout";
import LoginHandler from "./pages/LoginHandler";
import Admindash from "./Seobix/Dashboard";
import EmailData from "./Seobix/EmailData";
import QuotaUsage from "./Seobix/Quotahistory";
import Support from "./Seobix/Support";
import Leads from "./Seobix/Leads";
import PartnerQuery from "./Seobix/PartnerQuery";
import ProtectedAdminRoute from "./components/ProtectedAdminRoute";

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<LoginHandler />} />

    <Route
      path="/admin"
      element={
        <ProtectedAdminRoute>
          <DashboardLayout />
        </ProtectedAdminRoute>
      }
    >
      <Route path="support" element={<Support />} />
      <Route path="leads" element={<Leads />} />
      <Route path="partner-query" element={<PartnerQuery />} />
      <Route path="email-data" element={<EmailData />} />
      <Route path="quotaUsage" element={<QuotaUsage />} />
      <Route path="dashboard" element={<Admindash />} />
    </Route>
  </Routes>
);

export default AppRoutes;
